import { render, staticRenderFns } from "./ProductDocumentDialog.vue?vue&type=template&id=64806920"
import script from "./ProductDocumentDialog.vue?vue&type=script&lang=js"
export * from "./ProductDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDocumentDialog.vue?vue&type=style&index=0&id=64806920&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports